import { ApiStatus } from '../components/api-status';
import { ViewGuard } from '@/components/auth/PermissionGuards';

export default function ApiStatusPage() {
  return (
    <ViewGuard section="scheduler" fallback={
      <div className="flex items-center justify-center h-full">
        <div className="text-center p-8">
          <div className="mb-4">
            <span className="material-icons text-6xl text-gray-400">block</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600">You don't have permission to view API Status</p>
        </div>
      </div>
    }>
    <div className="w-full p-6">
      <h1 className="text-2xl font-bold mb-6">API Connection Status</h1>
      <p className="mb-6">
        This page tests the connections to various API endpoints using the simplified backend.
      </p>
      
      <ApiStatus />
    </div>
    </ViewGuard>
  );
}
